import { TextField } from '@material-ui/core';

import { DeliveryPointDetails } from '../../types/delivery-point-details.type';
import { DeliveryPointSegment } from '../../types/delivery-point.type';
import { DeliveryPointFieldChange } from '../../hooks/use-delivery-point-edit-form.hook';
import { DeliveryPointSegmentAutocomplete } from '../Forms/DeliveryPointSegmentAutocomplete.component';
import { isCompanyType } from '../../utils/delivery-point-form-rules.util';
import { DeliveryPointCard } from './DeliveryPointCard.component';

const DISCOUNT_CLEAR_REFUSED_MESSAGE = "La suppression d'une remise n'est pas encore possible depuis cet écran";

type Props = {
  updatedDeliveryPoint: DeliveryPointDetails;
  attachedSegment?: DeliveryPointSegment;
  isDiscountClearRefused: boolean;
  onSegmentSelect: (segment: DeliveryPointSegment | null) => void;
  onFieldChange: (change: DeliveryPointFieldChange) => void;
  onDiscountInput: (rawValue: string) => void;
};

export function DeliveryPointAdministrativeCard({
  updatedDeliveryPoint,
  attachedSegment,
  isDiscountClearRefused,
  onSegmentSelect,
  onFieldChange,
  onDiscountInput,
}: Props) {
  return (
    <DeliveryPointCard title="Administratif">
      <DeliveryPointSegmentAutocomplete
        id="delivery-point-segment"
        value={updatedDeliveryPoint.segment ?? null}
        attachedSegment={attachedSegment}
        onChange={onSegmentSelect}
      />
      <TextField
        id="delivery-point-invoicing-number"
        label="Numéro de facturation"
        type="text"
        size="small"
        variant="outlined"
        value={updatedDeliveryPoint.invoicingNumber ?? ''}
        onChange={(event) => onFieldChange({ field: 'invoicingNumber', value: event.target.value })}
      />
      <TextField
        id="delivery-point-siret"
        label="Siret"
        type="text"
        size="small"
        variant="outlined"
        value={updatedDeliveryPoint.siret ?? ''}
        onChange={(event) => onFieldChange({ field: 'siret', value: event.target.value })}
      />
      {isCompanyType(updatedDeliveryPoint.type) && (
        <TextField
          id="delivery-point-discount"
          label="Remise (%)"
          type="number"
          size="small"
          variant="outlined"
          error={isDiscountClearRefused}
          helperText={isDiscountClearRefused ? DISCOUNT_CLEAR_REFUSED_MESSAGE : undefined}
          value={updatedDeliveryPoint.discount?.value ?? ''}
          onChange={(event) => onDiscountInput(event.target.value)}
        />
      )}
    </DeliveryPointCard>
  );
}
